// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const meltan: PokeData = {
  "id": 808,
  "name": "meltan",
  "height": 2,
  "weight": 80,
  "base_experience": 135,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "headbutt",
    "tail-whip",
    "thunder-shock",
    "thunder-wave",
    "harden",
    "acid-armor",
    "flash-cannon"
  ],
  "moves": [
    "headbutt",
    "thunder-shock",
    "gear-up",
    "metal-claw",
    "smart-strike",
    "steel-beam",
    "metal-rush",
    "magnet-pull",
    "iron-defense",
    "metal-sound",
    "magnet-bomb",
    "behemoth-bash"
  ],
  "evolution_chain": {
    "id": 428,
    "item": null,
    "species": [
      {
        "name": "meltan",
        "order": 808,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 68,
    "ability_power": 130
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
